<template>
    <div class="hot_div" v-if='is_prompt'>
        <!-- 提示弹窗 -->
        <div class="popup_prompt" >
            <div class="prompt_div">
                    <i class="esc" @click="is_prompt = false"><img src="@/assets/img/shutDown.png" alt=""></i>
                <h5 class="prompt_title">提示</h5>
                <div class="prompt_text">
                    尊敬的用户，遵照相关法规，此内容仅对医疗专业人员开放，请完成基本信息后观看，给您带来的不便，敬请见谅！
                </div>
                <button class="confirm flex_center" @click.stop="confirm">确认</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'popup',
        data() {
            return {
                is_prompt:false,
            }
        },
        props: {

        },
        watch: {

        },
        methods: {
            popupFun(){
                this.is_prompt = !this.is_prompt;
            },
            confirm(){
                this.popupFun();
                this.$emit('promptFun');
            },


        },
        mounted() {

        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .popup_prompt{
        position: fixed;
        top:0;
        left:0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,.4);
        z-index: 999;
    }
    .prompt_div{
        position: absolute;
        top:50%;
        left: 50%;
        max-width:65vw;
        width: 400px;
        transform: translate(-50%,-50%);
        background: #fff;
        padding: 2rem;
        border-radius: 1vw;
    }
    .prompt_div .prompt_title{
        font-size: 2rem;
        padding-bottom: 1.4rem;
        border-bottom: .05rem solid #E8E8E8;
        color:#333;
        font-weight: bold;
        text-align: center;
    }
    .prompt_div .prompt_text{
        padding: 1.4rem 0;
        font-size:1.5rem;
        color:#1a1a1a;
        line-height: 1.6em;
    }
    .prompt_div .confirm{
        width: 90%;
        margin: 1rem auto 0 auto;
        height: 4rem;
        color:#fff;
        background: #F24D5B;
        border-radius: 2rem;
        font-size: 2rem;
        border:0;
    }
    .prompt_div .esc {
        position: absolute;
        top: 14px;
        right: 14px;
        width: 25px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/assembly/LoginPrompt.vue